import { OneLineText } from './OneLineText';

export class OneLineCounter extends OneLineText {
  private amount: number;
  private amountDisplayed: number;
  private amountMaxInterval: number;
  private amountMaxNegInterval: number;

  private preText: string;
  private postText: string;

  private tween: Phaser.Tween | null;

  constructor(
    x: number,
    y: number,
    font: string,
    amount: number,
    size: number,
    width: number,
    hAnchor: number,
    vAnchor: number,
    preText: string = '',
    postText: string = '',
  ) {
    super(x, y, font, '', size, width, hAnchor, vAnchor);

    this.amount = amount;
    this.amountDisplayed = amount;
    this.amountMaxInterval = 5;
    this.amountMaxNegInterval = -5;

    this.preText = preText || '';
    this.postText = postText || '';

    this.setText(this.preText + amount + this.postText);
  }

  public changeAmount(amount: number, immediately: boolean = false): void {
    if (immediately) {
      this.amount = amount;
      this.setText(this.preText + this.amount + this.postText);
    } else {
      this.tweenAmount(amount);
    }
  }

  private tweenAmount(amount: number): void {
    var self = this;
    var _amount = this.amount;
    this.amount = amount;
    const tweenConf = {
      get amount() {
        return _amount;
      },
      set amount(value) {
        _amount = value;
        self.setText(self.preText + Math.round(_amount) + self.postText);
      },
    }
    if (this.tween) {
      if (this.tween.isRunning) this.tween.stop();
      this.tween = null;
    }
    this.tween = this.game.add.tween(tweenConf)
      .to({
        amount: amount
      }, 600, Phaser.Easing.Circular.Out, true);
    this.tween.onComplete.add(() => {
      this.tween = null;
    });
  }
}